// Function to format a date as YYYY-MM-DD
function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

// Function to set min and max dates
function setDateTimeRange() {
  const dateInput = document.getElementById("date");

  if (dateInput) {
    // Get today's date and time
    const today = new Date();

    // Set min date to tomorrow
    const minDate = new Date(today);
    minDate.setDate(today.getDate() + 1); // Add 1 day
    dateInput.min = formatDate(minDate);

    // Set max date to 2 years from now
    const maxDate = new Date(today);
    maxDate.setFullYear(today.getFullYear() + 2); // Add 2 years
    dateInput.max = formatDate(maxDate);
  }
}

// Track whether the time picker is open
let isTimePickerOpen = false;

// Function to open or close the time picker
function toggleTimePicker() {
  const timeInput = document.getElementById("time");
  const customTimeIcon = document.getElementById("customTimeIcon");

  if (timeInput && customTimeIcon) {
    if (isTimePickerOpen) {
      // If the picker is open, blur the input to close it
      timeInput.blur();
      isTimePickerOpen = false;
    } else {
      // If the picker is closed, open it
      timeInput.showPicker();
      isTimePickerOpen = true;
    }
    // Toggle the rotation class
    customTimeIcon.classList.toggle("rotate-icon");
  }
}

// Initialize time picker click handler if elements exist
document.addEventListener("DOMContentLoaded", function () {
  const customTimeIcon = document.getElementById("customTimeIcon");
  const timeInput = document.getElementById("time");

  // Only add event listeners if elements exist
  if (customTimeIcon && timeInput) {
    customTimeIcon.addEventListener("click", toggleTimePicker);

    // Listen for the `blur` event on the time input to update the state
    timeInput.addEventListener("blur", () => {
      isTimePickerOpen = false;
      customTimeIcon.classList.remove("rotate-icon"); // Rotate back
    });
  }

  // Call date range function
  setDateTimeRange();

  // Hidden field functionality
  const hiddenField = document.getElementById("hidden-time");

  // Only proceed if both elements exist
  if (timeInput && hiddenField) {
    // Function to update the hidden field
    function updateHiddenField() {
      // Get the selected time value (in 24-hour format: "HH:MM")
      const timeValue = timeInput.value;

      // If there's a time value
      if (timeValue) {
        // Set the hidden field value
        hiddenField.value = timeValue;
      }
    }

    // Listen for changes on the time input
    timeInput.addEventListener("change", updateHiddenField);
    timeInput.addEventListener("input", updateHiddenField);

    // Initial update in case there's a default value
    updateHiddenField();
  }
});
